<template>
    <div class="rp-messenger-header__conversation-list" :style="messengerStyle">
		<BackButton
			@click="$emit('onBackButtonClick')"
		/>
		<div class="rp-messenger-header__conversation-list-title animated fast fadeInRight">
			{{$t(listHeader)}}
		</div>
    </div>
</template>

<script>
import BackButton from './BackButton'

export default {
	props: {
		messengerStyle: {
			type: Object,
			required: true
    },
    listHeader: String,
	},
	components: {
		BackButton
	}
}
</script>

<style lang="scss">


@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(30px, 0, 0);
    transform: translate3d(30px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(30px, 0, 0);
    transform: translate3d(30px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}


.rp-messenger-header__conversation-list {
	display: flex;
	align-items: center;
	padding: 0.8rem 1rem 0.8rem 0.8rem;
  background-color: var(--theme-background-color)
}

.rp-messenger-header__conversation-list-title {
	text-align: left;
	margin-left: 10px;
  font-weight: 500;
	//margin-left: -$backButtonSize;
	flex: 1;
}

</style>